import type { StreetViewPublicKeys } from "../../shared/street-view-keys.ts";

let keys: StreetViewPublicKeys = { naver_map_key_id: null, kakao_map_js_key: null };

export function setStreetViewKeys(next: StreetViewPublicKeys): void {
  keys = next;
}

export function getStreetViewKeys(): StreetViewPublicKeys {
  return keys;
}
